import { ToggleSwitch } from "flowbite-react"
import { FC, PropsWithChildren } from "react"
import useTheme from "../hooks/useTheme"

export type Props = PropsWithChildren<{
  className?: string
}>

export const CustomDarkThemeToggle: FC<Props> = ({ className }) => {
  const { theme, setTheme } = useTheme()

  return (
    <ToggleSwitch
      aria-label={
        theme === "dark" ? "Currently dark mode" : "Currently light mode"
      }
      className={className}
      checked={
        theme === "dark"
          ? true
          : theme === "light"
          ? false
          : document.documentElement.classList.contains("dark")
      }
      label=""
      onChange={() => {
        setTheme(
          document.documentElement.classList.contains("dark") ? "light" : "dark"
        )
      }}
    />
  )
}
